import store from 'store'

// 로컬 사용자 키(app.user.*) 일괄 제거 — 무의존 유틸 (redux/api/i18n import 금지, extensionBridge 패턴).
// landing.removeAllAppUserKeys(TOTP 지문·메모 초안 정리 포함 chokepoint)의 localStorage 순회부이며,
// 로그인 중 차단 처리(pUtils.login)도 직접 사용한다 — pUtils → landing import는 순환(landing이
// pUtils를 import)이라 분리. 로그인 도중 차단은 신규 세션 미성립 상태라 키 정리만으로 충분.
export const removeLocalAppUserKeys = () => {
  if (typeof localStorage !== 'undefined') {
    const keysToRemove = []
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i)
      if (key && key.startsWith('app.user.')) {
        keysToRemove.push(key)
      }
    }
    keysToRemove.forEach((key) => store.remove(key))
  }
}

export default removeLocalAppUserKeys
